import type { Faq } from "@/data/serviceFaqs";
import type { ServiceArea } from "@/data/serviceAreas";

/**
 * City-page FAQ content. Generated from the service-area record so the rendered
 * FAQ section and the FAQPage JSON-LD on /service-areas/$slug never drift.
 */
export function areaFaqs(area: ServiceArea): Faq[] {
  const city = area.name;
  const faqs: Faq[] = [
    {
      q: `How much does home theater installation cost in ${city}, CO?`,
      a: `Most ${city} media rooms land between $8,000 and $25,000 installed, covering the projector or large-format display, speakers, amplification, acoustic treatment, and control. A fully dedicated theater with tiered seating, isolated walls, and a reference-grade front stage typically runs $45,000 and up. Every Apex AV quote is fixed-bid after a free in-home walkthrough — no allowances or surprise change orders.`,
    },
    {
      q: `Do you offer free in-home consultations in ${city}?`,
      a: `Yes. We come to your ${city} home (${area.zip} and surrounding zips), measure ceiling cavities and wall construction, review existing low-voltage runs and panel capacity, then send a written scope and price. There is no charge and no obligation.`,
    },
    {
      q: `Can you retrofit smart home wiring in an existing ${city} house?`,
      a: `Almost always. Retrofit is the majority of our ${city} work: fishing cable through finished walls, adding in-ceiling speakers, pulling network drops to each floor, and patching and texturing so the finish matches. Where a wall truly can't be opened, we use wireless mesh audio and keypads to fill the gap.`,
    },
    {
      q: `How long does a typical ${city} installation take?`,
      a: `A TV mount with in-wall power is a half day. Whole-home audio or a network overhaul is usually two to four days. A dedicated theater or full automation package on a remodel runs two to six weeks depending on trades and lead times. We give you a dated schedule before work starts.`,
    },
    {
      q: `Do you work with ${city} builders and remodelers on new construction prewire?`,
      a: `Yes — we prewire during the framing stage for builders and homeowners throughout ${city}, then return after drywall for trim-out and commissioning. Getting us in before insulation is the cheapest possible time to future-proof a home.`,
    },
  ];

  if (area.hoaNotes) {
    faqs.push({
      q: `Will my ${city} HOA or permit review affect the install?`,
      a: area.hoaNotes,
    });
  }

  faqs.push({
    q: `What areas near ${city} do you serve?`,
    a: `We cover ${city} and the wider Denver metro and Front Range, including Denver, Lakewood, Arvada, Littleton, Highlands Ranch, Castle Rock, Castle Pines, Aurora, Centennial, Parker, Golden, Cherry Creek, Greenwood Village, and Boulder.`,
  });

  return faqs;
}
